import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "exercise-routine-form" }
const _hoisted_2 = { class: "exercise-routine-form-info" }
const _hoisted_3 = { class: "exercise-routine-form-item" }
const _hoisted_4 = { class: "exercise-routine-form-purpose-container" }
const _hoisted_5 = ["id", "value"]
const _hoisted_6 = ["for"]
const _hoisted_7 = { class: "modal-footer-buttons" }

import {
  onMounted,
  reactive,
  ref,
  getCurrentInstance,
} from "vue";
import { processing, processend } from "@/utils/view";
import { _$t } from "@/utils/i18n";

import ErrorDialog from "@/views/base/CommonMessage.vue";
import Modal from "@/views/base/ModalComponent.vue";
import { ExerciseHabit } from "@/models/myRecord/exerciseHabit";

type Option = {
  option_id: number;
  display_name: string;
};

// ---- props ----------------------------------------
const componentId = "healthcaredata02-04-a-modal";

export default /*@__PURE__*/_defineComponent({
  __name: 'ExerciseHabitModal',
  props: {
    exerciseRoutineOptionId: { default: null }
  },
  emits: ["close", "fetch-info"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// コンポーネントID
const sessionErr = ref(false);
const isInitialized = ref<boolean>(false);
const exerciseHabitOptions = ref<Option[]>([]);
const selectedExerciseOption = ref<number | null>(
  props.exerciseRoutineOptionId
);

// ▼ トースト表示用
const { appContext } = getCurrentInstance()!;
const $toast = appContext.config.globalProperties.$toast;

const emit = __emit;

// --- Error Dialog -------------------------------------------
let errorDialogSet = reactive({
  show: false,
  okButtonHide: true,
  safe: false,
  message: "",
  open: (message: string): void => {
    processing();
    errorDialogSet.message = message;
    errorDialogSet.show = true;
  },
  close: (): void => {
    processend();
    errorDialogSet.show = false;
    errorDialogSet.message = "";
    if (sessionErr.value) {
      window.location.replace("/cms/login");
    }
  },
});

// --- Event handlers --------------------------------------------
const fetchExerciseHabit = async () => {
  const exerciseHabit = new ExerciseHabit();
  const [_model, response, err] = await exerciseHabit.getExerciseHabits();
  if (err) {
    const decodedMessage = decodeURIComponent(
      err.error?.response?.data?.message
    );
    const status = err.error?.response?.status;
    if (status === 408) {
      // セッションエラー
      sessionErr.value = true;
    }
    errorDialogSet.open(decodedMessage);
    return;
  }
  exerciseHabitOptions.value = response.data;

  // 未選択時は「1日」をデフォルト選択
  if (!selectedExerciseOption.value) {
    const defaultOption = exerciseHabitOptions.value.find(
      (option) => option.display_name === "1日"
    );
    selectedExerciseOption.value =
      defaultOption?.option_id ??
      exerciseHabitOptions.value[0]?.option_id ??
      null;
  }
};

// 閉じるボタン押下時処理
function onClose() {
  emit("close");
}

async function handleSaveButtonClick() {
  if (!selectedExerciseOption.value) {
    errorDialogSet.open(_$t("exercise_habit_modal_select_message"));
    return;
  }
  await save();
}

async function save() {
  const exerciseHabit = new ExerciseHabit();
  const [_model, response, err] = await exerciseHabit.save(
    selectedExerciseOption.value!
  );
  if (err) {
    const status = err.error.response.status;
    const decodedMessage = decodeURIComponent(
      err.error?.response?.data?.message
    );
    // セッションエラー
    if (status === 408) sessionErr.value = true;
    errorDialogSet.open(decodedMessage);
    return;
  }

  // 完了メッセージ表示
  $toast({
    message: `${_$t("exercise_habit_modal_title")}${_$t(
      "common_message_saved"
    )}`,
    icon: "success",
  });
  onClose();
  emit("fetch-info");
}

// --- Vue lifecycle --------------------------------------------
onMounted(async () => {
  // 初期設定
  await fetchExerciseHabit();
  isInitialized.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Modal, {
      modalClass: "modal-exercise-routine-add",
      id: componentId,
      title: _unref(_$t)('exercise_habit_modal_title'),
      closable: true,
      overlayClosable: true,
      escClosable: true,
      showTab: false,
      actions: [],
      onClose: onClose
    }, _createSlots({
      footerButton: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: "modal-cansel",
            onClick: onClose
          }, _toDisplayString(_ctx.$t("common_button_cancel")), 1),
          _createElementVNode("button", {
            type: "button",
            class: "modal-ok",
            onClick: handleSaveButtonClick
          }, _toDisplayString(_ctx.$t("common_button_save")), 1)
        ])
      ]),
      _: 2
    }, [
      (isInitialized.value)
        ? {
            name: "bodyInfo",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("p", _hoisted_2, [
                  _createTextVNode(_toDisplayString(_ctx.$t("exercise_habit_modal_label_info")) + " ", 1),
                  _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("exercise_habit_modal_label_info_note")), 1)
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(exerciseHabitOptions.value, (option, key) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: `exercise-routine-${key}`,
                          name: "purpose",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedExerciseOption).value = $event)),
                          value: option.option_id,
                          class: "exercise-routine-form-purpose-radio"
                        }, null, 8, _hoisted_5), [
                          [_vModelRadio, selectedExerciseOption.value]
                        ]),
                        _createElementVNode("label", {
                          for: `exercise-routine-${key}`,
                          class: "exercise-routine-form-purpose-button"
                        }, _toDisplayString(option.display_name), 9, _hoisted_6)
                      ], 64))
                    }), 128))
                  ])
                ])
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["title"]),
    (_unref(errorDialogSet).show)
      ? (_openBlock(), _createBlock(ErrorDialog, _mergeProps({ key: 0 }, _unref(errorDialogSet), {
          onOk: _unref(errorDialogSet).close,
          onCancel: _unref(errorDialogSet).close
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})